import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/feature/BackToTop';
import Hero from '@/pages/home/components/Hero';
import FocusAreas from '@/pages/home/components/FocusAreas';
import Tracking from '@/pages/home/components/Tracking';
import Comparison from '@/pages/home/components/Comparison';
import CaseCollection from '@/pages/home/components/CaseCollection';
import HorizontalAnalysis from '@/pages/home/components/HorizontalAnalysis';
import TopicCategories from '@/pages/home/components/TopicCategories';
import Faq from '@/pages/home/components/Faq';
import Brand from '@/pages/home/components/Brand';
import Contact from '@/pages/home/components/Contact';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main className="w-full">
        <Hero />
        <FocusAreas />
        <Tracking />
        <Comparison />
        <CaseCollection />
        <HorizontalAnalysis />
        <TopicCategories />
        <Faq />
        <Brand />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}